// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + {"318":"507c0de5c9a4138c7af9","669":"b291e10503644007c50b","795":"a4cf5182b1bccb3916ce","796":"083b80526ab8dbd33d83","820":"e2a369801a10dbba1c08"}[chunkId] + ".js";
};